import BodyText, { BodyTextProps } from "components/Typography/BodyText"
import { memo, useCallback, useState } from "react"
import styled from "styled-components"
import clsx from "clsx"

const IconContainer = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -5px;
  cursor: pointer;
  display: flex;
`

const RefreshIcon = styled.div`
  position: absolute;
  padding-left: 208px;
  transform: translateY(-50%);
  z-index: 2;
  font-size: 24px;
  color: ${(props) => props.theme.palette.subtitle};
  cursor: pointer;
  user-select: none;
`

const ContainerInformative = styled.div`
  top: -2px;
  width: 232px;
  text-align: center;
  border-radius: 8px;
  padding: 8px;
  position: absolute;
  left: -22px;
  z-index: 3;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.3s,
    visibility 0.3s;
  background-color: ${(props) => props.theme.palette.white};
  box-shadow: 5px 5px 15px rgba(69, 69, 69, 0.087);
  border: 0.5px solid ${(props) => props.theme.palette.disabled};

  &.visible {
    opacity: 1;
    visibility: visible;
  }

  &.bottom {
    top: 24px;
    width: 232px;
  }
`

interface PartialDisplayProps {
  content?: string
  maxLength?: number
  contentSize?: BodyTextProps["size"]
  contentColor?: BodyTextProps["color"]
  modal?: boolean
  className?: string
  onClick?: (key: string) => void
  showButton?: boolean
}

const ShowMoreButton = styled.div`
  margin-left: 5px;
  color: ${(props) => props.theme.palette.primary_dark};
`

function PartialDisplay(props: PartialDisplayProps) {
  const {
    content = "",
    maxLength,
    contentSize = "medium",
    contentColor = "primary-dark",
    modal,
    className,
    onClick,
    showButton
  } = props
  const [showComplete, setShowComplete] = useState(false)

  const textDisplayed = showComplete ? content : content?.slice(0, maxLength).concat("...")

  const textPartial = content?.slice(0, maxLength).concat("...")

  const handleStateValue = useCallback(() => {
    setShowComplete((prevShowComplete) => !prevShowComplete)
  }, [])

  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(content)
    }
  }, [onClick, content])

  if (maxLength && content?.length < maxLength) {
    return <span>{content}</span>
  }

  return (
    <div>
      {!modal && <span>{textDisplayed}</span>}
      {modal && <span>{textPartial}</span>}
      {showButton && (
        <button onClick={handleStateValue}>
          <BodyText size={contentSize} weight="bold" color={contentColor}>
            <ShowMoreButton onClick={handleClick}>{showComplete ? ` menos` : ` mais`}</ShowMoreButton>
          </BodyText>
        </button>
      )}
      {modal && (
        <RefreshIcon>
          <IconContainer>
            <ContainerInformative className={clsx({ visible: showComplete }, className)}>
              <BodyText size="small" color="primary-dark">
                {content}
              </BodyText>
            </ContainerInformative>
          </IconContainer>
        </RefreshIcon>
      )}
    </div>
  )
}

export default memo(PartialDisplay)
